export const ExternalLinks = {
  HOME: "https://www.restore.com",
  TERMS: "https://www.restore.com/terms",
  LOCATIONS: "https://www.restore.com/locations",
  FAQS: "https://www.restore.com/faq",
  PRIVACY_POLICY: "https://www.restore.com/privacy-policy",
} as const;
